import { ERROR_CODE } from '@config/errors';

import { getCurrentDate, isValidDate } from '@helpers/date';

import { DateTimeRangeValidator } from './types';

export const dateTimeRangeValidator: DateTimeRangeValidator = (
  value,
  options
) => {
  const { dateFrom, dateTo } = value;

  if (!dateTo || !dateFrom) {
    return options.message ?? ERROR_CODE.DATES_REQUIRED;
  }

  if (!isValidDate(dateFrom)) {
    return options.message ?? ERROR_CODE.START_DATE_INVALID_FORMAT;
  }

  if (!isValidDate(dateTo)) {
    return options.message ?? ERROR_CODE.END_DATE_INVALID_FORMAT;
  }

  if (dateTo > getCurrentDate()) {
    return options.message ?? ERROR_CODE.END_DATE_OUT_OF_RANGE;
  }

  if (dateTo <= dateFrom) {
    return options.message ?? ERROR_CODE.DATE_RANGE_INVALID;
  }

  return undefined;
};
